import React from 'react';
import { Modal, DatePicker, DropdownSelector } from 'hyperdb-utils';

const ModalSelectedDates = ({
  dateFrom, dateTo, actionDatesSelected, selectedUnit, units,
  onChange, onClose, onConfirmAction, loading = false
}) => {
  const propertiesListOptions = () => {
    return units
      .filter(unit => unit.isLocal)
      .filter(unit => !unit.is_multi_units || unit.number === 1)
      .map(unit => {
        const id = unit.number && !unit.is_multi_units ? `${unit.property_id}_${unit.number}` : unit.property_id;
        const name = unit.is_multi_units ? unit.property_name : unit.label;
        return { name, value: id };
      });
  };
  const openFrom = dateFrom && dateTo ? (dateFrom < dateTo ? dateFrom : dateTo) : dateTo || dateFrom;
  const openTo = dateFrom && dateTo ? (dateFrom > dateTo ? dateFrom : dateTo) : dateFrom || dateTo;
  return (
    <Modal title="Selected dates" onClose={ onClose } onAccept={ onConfirmAction } loading={ loading }>
      <DatePicker
        label="Start date"
        name="dateFrom"
        value={ dateFrom }
        maxValue={ dateTo }
        openToDate={ openFrom }
        onChange={ onChange.bind(null, 'dateFrom') }
      />
      <DatePicker
        label="End date"
        name="dateTo"
        value={ dateTo }
        minValue={ dateFrom }
        openToDate={ openTo }
        onChange={ onChange.bind(null, 'dateTo') }
      />
      <DropdownSelector
        placeholder="Select an action"
        name="action"
        value={ actionDatesSelected }
        options={ [
          { name: 'Block dates', value: 'block' },
          { name: 'Unblock dates', value: 'unblock' },
        ] }
        onChange={ onChange.bind(null, 'actionDatesSelected') }
      />
      {
        actionDatesSelected
          ? <DropdownSelector
              placeholder="--- Select ---"
              name="property"
              value={ selectedUnit }
              options={ propertiesListOptions() }
              onChange={ onChange.bind(null, 'selectedUnit') }
            />
          : null
      }
    </Modal>
  );
};

export default ModalSelectedDates;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/ModalSelectedDates.jsx